
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hosts/[host]/[[...page]]",
      function () {
        return require("private-next-pages/hosts/[host]/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hosts/[host]/[[...page]]"])
      });
    }
  